import type { UserRole } from '../types/auth'

const PUBLIC_PATHS = new Set(['/login', '/register', '/welcome', '/demo'])

export function isAdminPath(pathname: string): boolean {
  return pathname === '/admin' || pathname.startsWith('/admin/')
}

export function resolvePostLoginPath(
  role: UserRole | undefined,
  impersonating: boolean,
  fallback = '/'
): string {
  if (impersonating) {
    return fallback
  }
  if (role === 'super_admin') {
    return '/admin'
  }
  return fallback
}

export function resolveAuthenticatedRedirect(input: {
  pathname: string
  role?: UserRole
  impersonating: boolean
}): string | null {
  const { pathname, role, impersonating } = input
  if (PUBLIC_PATHS.has(pathname) || pathname === '/profile') {
    return null
  }

  const isSuperAdmin = role === 'super_admin' && !impersonating
  if (isSuperAdmin && !isAdminPath(pathname)) {
    return '/admin'
  }
  if (!isSuperAdmin && isAdminPath(pathname)) {
    return '/'
  }
  return null
}
